export default {
  pricings: [],
  pricing: undefined,
};
